declare const pdfMake;

import { Component, OnInit, Input, ViewChild, TemplateRef, ElementRef, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { Contract } from '../model/contract'
import { Article } from '../model/article'
import { ContractService } from '../service/contract.service'

import { DragulaService } from 'ng2-dragula/ng2-dragula'
import { PdfExportService } from '../service/pdf-export.service';
import { WordExportService } from '../service/word-export.service';
import { WordToPdfExportService } from '../service/word-to-pdf-export.service';

import { environment } from './../../environments/environment';
import * as firebase from 'firebase';
import * as $ from 'jQuery';

import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.css']
})

export class ContractComponent implements OnInit {

  @Input()
  contract: Contract;

  contractCopy: Contract;

  private id: string;
  private template: number;
  private queryParamSubscription: any;
  private routeParamSubscription: any;

  public isContractValid = false;
  public show: boolean = false;

  @ViewChild('canvas') public canvas: ElementRef;
  private cx: CanvasRenderingContext2D;

  constructor(private spinner: NgxSpinnerService, private router: Router,private route: ActivatedRoute, private contractService: ContractService, private dragulaService: DragulaService, private pdfExportService: PdfExportService, private wordExportService: WordExportService, private wordToPdfExportService: WordToPdfExportService) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd){
        (<any>window).spinner = this.spinner;
        this.spinner.show();
        // IZMJENA TESTIRANJE - DMILIC
        // $('').addClass('loading-links');
        $('local-link').addClass('loading-links');
        setTimeout(()=>{
          $.each($(".statement-textarea"), function (i, element) {
            element.style.height = 'auto';
            element.style.height = element.scrollHeight + "px";
          });
          if (!!$('.local-link').length)  $('.local-link').each(function (index, el) {
              $(el).click(function (e) {
                e.preventDefault();
                let params = $(el).attr('href').split('?');
                params = params[params.length - 1];
                params = params.split('=');
                let queries = {};
                queries[params[0]] = params[1];

                (<any>window).router.navigate(['/contract'], { queryParams: queries });
              })
          }, 2000);
          setTimeout(() => {
            (<any>window).spinner.hide();
          }, 2000);
        })
      }
    })
    }

  getArticleNumber(index: number) {
    return this.contract.articles.slice(0, index).filter(a => !a.dummy).length + 1;
  }

  /**
   * Generates simple 4-character UID.
   */
  private generateSimpleUID() {
    return ("0000" + (Math.random()*Math.pow(36,4) << 0).toString(36)).slice(-4);
  }

  /**
   * Assigns ID's to contract's articles and article's statements.
   * Will be done by editor in future.
   */
  private assignContractIds() {
    for (let i=0;i < this.contract.articles.length;i++) {
      this.contract.articles[i].id = this.generateSimpleUID();
      for (let j=0; j < this.contract.articles[i].statements.length; j++) {
        this.contract.articles[i].statements[j].id = this.generateSimpleUID();
      }
    }
  }

  ngOnInit() {

    if (environment.production && !firebase.auth().currentUser) {
      this.router.navigate(['/']);
    };

    // Handle contract creation from template
    this.queryParamSubscription = this.route.queryParams.subscribe(params => {
      this.template = +params['template'];
      if (this.template) {
        this.contract = this.contractService.getTemplate(this.template);
        this.contract.name = this.contract.templateTitle;
        this.assignContractIds();
        window.scrollTo(0,0);
      }
    });

    // Handle existing contract editing
    this.routeParamSubscription = this.route.params.subscribe(params => {
      this.id = params['id'];
      if (this.id) {
        this.contract = this.contractService.getContract(this.id);
        this.assignContractIds();
        window.scrollTo(0,0);
        // mark validity immediately on open
        this.isContractValid = this.validateContract(this.contract);
      }
    });

    // Set dragula regions to be draggable only by their handles
    this.dragulaService.setOptions('dragula-bag', {
      moves: function (el, container, handle) {
        return handle.className === 'handle';
      }
    });

    // Create contract copy for changes detection
    this.contractCopy = new Contract(JSON.stringify(this.contract));
  }

  ngOnDestroy() {
    this.queryParamSubscription.unsubscribe();
    this.routeParamSubscription.unsubscribe();
    this.dragulaService.destroy('dragula-bag');
  }

  /**
   * Removes an article from the contract
   * @param {*} article Article to remove.
   */
  removeArticle = article => {
    console.log("Remove article");
    console.log(article);

    for (let i=0;i < this.contract.articles.length;i++) {
      if (this.contract.articles[i].id == article.id) {
        this.contract.articles.splice(i, 1);
        return;
      }
    }
  }

  /**
   * Removes a statement from contract's article.
   * @param {*} statement Statement to remove.
   */
  removeStatement = statement => {
    console.log("Remove statement");
    console.log(statement);

    for (let i=0;i < this.contract.articles.length;i++) {
      for (let j=0; j < this.contract.articles[i].statements.length; j++) {
        if (this.contract.articles[i].statements[j].id == statement.id) {
          this.contract.articles[i].statements.splice(j, 1);
          return;
        }
      }
    }
  }

  /**
   * Inserts empty article after specified article.
   * @param {Article} article Article after which to insert a new one.
   */
  addArticle = article => {
    console.log("Add article");

    const emptyArticle = {
      id: this.generateSimpleUID(),
      mandatory: false,
      statements: [
        {
          id: this.generateSimpleUID(),
          type: "text",
          mandatory: true,
          editable: true,
          placeholder: "Unesite tekst ovdje..."
        }
      ]
    };

    for (let i=0;i < this.contract.articles.length;i++) {
      if (this.contract.articles[i].id == article.id) {
        this.contract.articles.splice(i+1, 0, new Article(JSON.stringify(emptyArticle)));
        return;
      }
    }
  }

  /**
   * Validates a contract.
   * @param {Contract} contract Contract to validate.
   */
  validateContract = contract => {

    let isInvalid = false;
    console.warn('contract je: ', contract);

    // validate sides
    for (let i=0; i < contract.sides.length; i++) {
      for (let j=0; j < contract.sides[i].inputs.length; j++) {
        if (contract.sides[i].inputs[j].required) {
          contract.sides[i].inputs[j].submitted = true;
          const isnum = /^\d+$/.test(contract.sides[i].inputs[j].value);

          if (contract.sides[i].inputs[j].required === true && contract.sides[i].inputs[j].placeholder == 'OIB' && (contract.sides[i].inputs[j].value === "" || !contract.sides[i].inputs[j].value || !isnum || contract.sides[i].inputs[j].value.length !== 11)) {
            isInvalid = true;
            console.log('invalid sides');
          }

          if (contract.sides[i].inputs[j].required === true && (contract.sides[i].inputs[j].value === "" || !contract.sides[i].inputs[j].value)) {
            isInvalid = true;
            console.log('invalid sides');
          }
        }
      }
    }

    // validate articles
    for (let i=0; i < contract.articles.length; i++) {
      contract.articles[i].hasErrors = false;
      for (let j=0; j < contract.articles[i].statements.length; j++) {

        // choice statement
        if (contract.articles[i].statements[j].type == 'choice') {
          if (contract.articles[i].statements[j].mandatory && (!contract.articles[i].statements[j].value || contract.articles[i].statements[j].value === "") ) {
            isInvalid = true;
            console.log('invalid choice');
            contract.articles[i].hasErrors = true;
          } else {
            if (contract.articles[i].statements[j].mandatory &&
              contract.articles[i].statements[j].choices[contract.articles[i].statements[j].value] &&
              contract.articles[i].statements[j].choices[contract.articles[i].statements[j].value].parts) {

              // validate parts
              for (let k=0; k < contract.articles[i].statements[j].choices[contract.articles[i].statements[j].value].parts.length; k++) {

                if (contract.articles[i].statements[j].choices[contract.articles[i].statements[j].value].parts[k].type === 'input') {
                  contract.articles[i].statements[j].choices[contract.articles[i].statements[j].value].parts[k].submitted = true;
                }

                if (contract.articles[i].statements[j].choices[contract.articles[i].statements[j].value].parts[k].required === true &&
                  contract.articles[i].statements[j].choices[contract.articles[i].statements[j].value].parts[k].value === "") {
                  isInvalid = true;
                      console.log('invalid parts');

                  contract.articles[i].hasErrors = true;
                }

              }

            }
          }
        }

        // input statement
        if (contract.articles[i].statements[j].parts) {
          for (let k=0; k < contract.articles[i].statements[j].parts.length; k++) {

            if (contract.articles[i].statements[j].parts[k].type === 'input') {
              contract.articles[i].statements[j].parts[k].submitted = true;
            }

            if (contract.articles[i].statements[j].parts[k].required === true && contract.articles[i].statements[j].parts[k].value === "") {
              isInvalid = true;
              console.log('invalid input statement');

              contract.articles[i].hasErrors = true;
            }

          }
        }
      }
    }

    return !isInvalid;
  }

  /**
   * Saves the contract.
   */
  save = () => {
    console.log("Saving contract");

    let redirect = false;
    // if (!this.contract.id) {
      this.contract.id = this.generateSimpleUID();
      this.contract.createdAt = new Date();
      redirect = true;
    // }

    // Validate contract
    this.isContractValid = this.validateContract(this.contract);

    // Save contract

    this.contractService.saveContract(this.contract);

    // Re-create contract copy for changes detection
    this.contractCopy = new Contract(JSON.stringify(this.contract));

    // if (redirect) {
    //   this.router.navigateByUrl('/contract/' + this.contract.id);
    // }
  }

  /**
   * Generates PDF file from contract and downloads it.
   * Contract is validated first and must be valid to export.
   */
  exportAsPdf = () => {
    console.log("Exporting contract as PDF");

    // Validate contract
    this.isContractValid = this.validateContract(this.contract);
    if (!this.isContractValid) {
      return;
    }

    // Export contract
    this.pdfExportService.exportAsPDF(this.contract);
  }

  exportAsWord = () => {
    console.log("Exporting contract as Word");

    // Validate contract
    this.isContractValid = this.validateContract(this.contract);
    if (!this.isContractValid) {
      return;
    }

    // Export contract
    this.wordExportService.exportAsDocx(this.contract);
  }

  exportAsWordToPdf = () => {
    console.log("Exporting contract as Word to PDF");

    // Validate contract
    this.isContractValid = this.validateContract(this.contract);
    if (!this.isContractValid) {
      return;
    }

    // Export contract
    this.wordToPdfExportService.exportAsDocxToPdf(this.contract);
  }

  hasChanges = () => {
    return JSON.stringify(this.contract) !== JSON.stringify(this.contractCopy);
  }

  ngOnChanges(...args: any[]) {
    console.log('onChange fired');
    console.log('changing', args);
  }

  bindLinks() {
    $('.local-link').each(function (index, el) {
      $(el).click(function (e) {
        e.preventDefault();
        let params = $(el).attr('href').split('?');
        params = params[params.length - 1];
        params = params.split('=');
        let queries = {};
        queries[params[0]] = params[1];

        (<any>window).router.navigate(['/contract'], { queryParams: queries });
      })
    })
  }

  ngAfterViewInit() {
    (<any>window).router = this.router;
    // this.isContractValid = this.validateContract(this.contract);
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    (<any>window).canvas = canvasEl;
    (<any>window).ctx = this.cx;
    var dpr = (<any>window).devicePixelRatio || 1
    var bsr = (<any>window).ctx.webkitBackingStorePixelRatio ||
      (<any>window).ctx.mozBackingStorePixelRatio ||
      (<any>window).ctx.msBackingStorePixelRatio ||
      (<any>window).ctx.oBackingStorePixelRatio ||
      (<any>window).ctx.backingStorePixelRatio || 1;
    (<any>window).ratio = dpr / bsr;
    console.log((<any>window).ctx.backingStorePixelRatio);
    (<any>window).ctx.setTransform((<any>window).ratio, 0, 0, (<any>window).ratio, 0, 0);
  }
}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contract/contract.component.ts